/**
 * @generated SignedSource<<1e5bf341cc148d46a52e8f74b476d624>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type ScreenersFilterTypeChoices = "PN" | "PT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ParticipantFilters_viewer$data = {
  readonly study: {
    readonly filters: ReadonlyArray<{
      readonly filters: any;
      readonly id: string;
      readonly name: string;
      readonly study: {
        readonly id: string;
      } | null;
      readonly type: ScreenersFilterTypeChoices;
      readonly user: {
        readonly id: string;
      } | null;
    }>;
    readonly id: string;
  } | null;
  readonly user: {
    readonly id: string;
    readonly profile: {
      readonly tenant: {
        readonly filters: ReadonlyArray<{
          readonly filters: any;
          readonly id: string;
          readonly name: string;
          readonly study: {
            readonly id: string;
          } | null;
          readonly type: ScreenersFilterTypeChoices;
          readonly user: {
            readonly id: string;
          } | null;
        }>;
        readonly id: string;
        readonly name: string;
      };
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DrawerFilters_viewer">;
  readonly " $fragmentType": "ParticipantFilters_viewer";
};
export type ParticipantFilters_viewer$key = {
  readonly " $data"?: ParticipantFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParticipantFilters_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "FilterNode",
  "kind": "LinkedField",
  "name": "filters",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StudyNode",
      "kind": "LinkedField",
      "name": "study",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filters",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "studyId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ParticipantFiltersViewerRefetchQuery.graphql')
    }
  },
  "name": "ParticipantFilters_viewer",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "StudyNode",
      "kind": "LinkedField",
      "name": "study",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TenantNode",
              "kind": "LinkedField",
              "name": "tenant",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "DrawerFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c5129ce1d4c322960c2f099a6f746bdf";

export default node;
